var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#E3EEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 48.5C53.5228 48.5 58 44.0228 58 38.5C58 32.9772 53.5228 28.5 48 28.5C42.4772 28.5 38 32.9772 38 38.5C38 44.0228 42.4772 48.5 48 48.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8201 68.5C30.8201 60.76 38.5201 54.5 48.0001 54.5C49.9201 54.5 51.7801 54.76 53.5201 55.24",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60.5C68 62 67.58 63.42 66.84 64.62C66.42 65.34 65.88 65.98 65.26 66.5C63.86 67.76 62.02 68.5 60 68.5C57.08 68.5 54.54 66.94 53.16 64.62C52.42 63.42 52 62 52 60.5C52 57.98 53.16 55.72 55 54.26C56.38 53.16 58.12 52.5 60 52.5C64.42 52.5 68 56.08 68 60.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.88 60.5L58.86 62.48L63.12 58.54",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsVerified);
export default __webpack_public_path__ + "static/media/patients-verified.c3bc0f6986a6e8250c7790bd73f27b32.svg";
export { ForwardRef as ReactComponent };